import { useInfiniteQuery } from '@tanstack/react-query';

import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants';

import type { PollFilters, PollListResponse } from '@/types/poll';

const KEYS = {
    all: ['polls'] as const,
    list: (filters: PollFilters) => [...KEYS.all, 'list', filters] as const,
};

export { KEYS as POLL_KEYS };

export function usePolls(filters: PollFilters = {}, options: { enabled?: boolean } = {}) {
    return useInfiniteQuery({
        queryKey: KEYS.list(filters),
        enabled: options.enabled ?? true,
        queryFn: async ({ pageParam = 0 }) => {
            const params: Record<string, string | number | boolean> = {
                limit: 10,
                offset: pageParam,
            };

            if (filters.ordering) params.ordering = filters.ordering;
            if (filters.status && filters.status !== 'all') params.status = filters.status;
            if (filters.mine) params.mine = true;
            if (filters.voted) params.voted = true;
            if (filters.search) params.search = filters.search;
            if (filters.is_quiz !== undefined) params.is_quiz = filters.is_quiz;

            const { data } = await api.get<PollListResponse>(API_ROUTES.polls, { params });
            return data;
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage) => {
            if (!lastPage.next) return undefined;
            try {
                const url = new URL(lastPage.next);
                const offset = url.searchParams.get('offset');
                return offset ? parseInt(offset, 10) : undefined;
            } catch {
                return undefined;
            }
        },
    });
}
